import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import vuetify from './plugins/vuetify';

import BootstrapVue3 from 'bootstrap-vue-3';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue-3/dist/bootstrap-vue-3.css';
import { loadFonts } from './plugins/webfontloader';
import { createMetaManager } from 'vue-meta';

loadFonts();
const app = createApp(App);
app.use(router);
app.use(vuetify);
app.use(BootstrapVue3);
app.use(createMetaManager());
app.mount('#app');
